/**
 * example:
 * interpolateTranslation('{{bank}} is good', {
 *              bank: 'barclays'
 * }) -> 'barclays is good'
 */
export function interpolateTranslation(translation, substitutions) {
    let result = translation;
    Object.entries(substitutions).forEach(([substitutionKey, substitutionValue]) => {
        result = result.replaceAll(`{{${substitutionKey}}}`, substitutionValue);
    });
    return result;
}
